module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1895655"
    }
  }, [_c('b', [_vm._v("POTATO AND LEEK SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1896155"
    }
  }, [_c('b', [_c('i', [_vm._v("By cutting out the heavy cream that is traditionally in this recipe, we reduced both the total fat and saturated fat by 4 grams each and dropped the cholesterol by a not-too-shabby 24 milligrams.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1897755"
    }
  }, [_c('b', [_vm._v("Prep: 15 minutes Cook: 28 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1898255"
    }
  }, [_vm._v("1½ pounds leeks (about 3 large)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1899355"
    }
  }, [_vm._v("1 tablespoon olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1899655"
    }
  }, [_vm._v("1 tablespoon butter or margarine")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1899955"
    }
  }, [_vm._v("12 ounces all-purpose potatoes, peeled and "), _c('br'), _vm._v(" cut into ½ -inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1901455"
    }
  }, [_vm._v("2 cans (14 to 14½ ounces each) reduced-sodium "), _c('br'), _vm._v(" chicken broth")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1902955"
    }
  }, [_vm._v("1 sprig plus 1 tablespoon chopped fresh dill")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1903255"
    }
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1904255"
    }
  }, [_vm._v("⅛ teaspoon ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1905155"
    }
  }, [_vm._v("1 cup whole milk")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1905455"
    }
  }, [_vm._v("2 teaspoons fresh lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1905955"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Cut off roots and trim dark green tops from leeks. Discard any tough outer leaves. Cut each leek lengthwise in half, then crosswise into ¼-inch-wide slices. Rinse leeks thoroughly in large bowl of cold water, swishing to remove sand. Transfer leeks by hand to colander to drain. Repeat process, changing water several times, until all sand is removed.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1910255"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In 4-quart saucepan, heat oil and butter on medium until butter melts. Add leeks and cook 8 to 10 minutes or until tender, stirring occasionally. Stir in potatoes, broth, dill sprig, salt, and pepper. Cover and heat to boiling on high. Reduce heat to low; simmer 15 minutes or until potatoes are very tender.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1912555"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Ladle potato mixture into blender in 3 batches; cover, removing center part of lid to let steam escape. Lay a paper towel over top and puree until smooth. Pour each batch of puree into bowl. Return to same saucepan and stir in milk; heat through. Stir in lemon juice and serve, garnishing with chopped dill. Makes 6 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1915955"
    }
  }, [_vm._v("Each serving: About 140 calories, 4g protein, 20g carbohydrate, 6g total fat (2g saturated), 2g fiber, 6mg cholesterol, 515mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d19d0c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c52_r1.vue
// module id = 222
// module chunks = 0